module.exports = __webpack_public_path__ + "static/media/InfoIcon.29fe80f4.svg";